/**
 * Chargement des recettes
 */

import React from "react";
import { glassPanel } from "../../../../components/layout/UserLayout/designTokens";
import { CardGridLoading } from "../../../../components/common/CardGridLoading";

export default function LoadingState({ t }) {
  return (
    <div className={`${glassPanel} rounded-2xl p-6 sm:p-8`}>
      <CardGridLoading
        message={t("loadingRecipes")}
        gridCols="grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
        count={6}
      />
    </div>
  );
}
